import * as Actions from 'store/actions/user/auth.actions'
import { LOCAL_STORAGE_LOGIN_USER_KEY, LOCAL_STORAGE_TOKEN_KEY } from 'constants/auth'
import { setItemLocalStorage, getItemLocalStorage, removeItemLocalStorage } from 'utils/local-storage'

const initialState = {
  loading: false,
  user: null,
  token: getItemLocalStorage(LOCAL_STORAGE_TOKEN_KEY),
  login_error: null,
}

const authReducer = function (state = initialState, { type, payload }) {
  switch (type) {
    case Actions.LOADING_LOGIN: {
      return {
        ...state,
        loading: payload,
      }
    }
    case Actions.LOGIN_SUCCESS: {
      setItemLocalStorage(LOCAL_STORAGE_TOKEN_KEY, payload.token)
      setItemLocalStorage(LOCAL_STORAGE_LOGIN_USER_KEY, payload.user.id)
      return {
        ...state,
        user: payload.user,
        token: payload.token,
        login_error: null,
      }
    }
    case Actions.LOGIN_ERROR: {
      return {
        ...state,
        user: null,
        login_error: payload,
      }
    }
    case Actions.LOGOUT: {
      removeItemLocalStorage(LOCAL_STORAGE_TOKEN_KEY)
      return {
        loading: false,
        user: null,
        token: null,
        login_error: null,
      }
    }
    case Actions.UPDATE_PROFILE_IMAGE: {
      return {
        ...state,
        user: { ...state.user, url_avatar: payload }
      }
    }
    case Actions.REMOVE_PROFILE_IMAGE: {
      return {
        ...state,
        user: { ...state.user, url_avatar: null }
      }
    }
    default: {
      return state
    }
  }
}

export default authReducer